import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, Skeleton, Typography } from '@mui/material';
import { keepPreviousData } from '@tanstack/react-query';
import useQueryObject from '../../../../hooks/useQueryObjectSql';
import { getAlertsMappedToTactic } from '../queries';
import { FilterContext, SelectedWidgetData, TableDataType } from '../types';
import TreemapWidget from './treemap';

interface AlertsMappedToTacticProps {
  filterContext: FilterContext;
  selected?: SelectedWidgetData;
  onSelect?: (selected: SelectedWidgetData) => void;
}

const AlertsMappedToTactic = (props: AlertsMappedToTacticProps) => {
  const { filterContext, selected, onSelect } = props;

  const { data, isLoading } = useQueryObject({
    queryObject: getAlertsMappedToTactic(filterContext),
    options: { placeholderData: keepPreviousData },
  });

  return (
    <Box sx={{ ...flex.col, padding: '16px 24px', height: '100%' }}>
      <Typography sx={{ whiteSpace: 'nowrap', mb: 1, fontSize: '18px', marginBottom: '16px' }} variant="h2">
        Alerts Mapped to MITRE ATT&CK® Tactics
      </Typography>
      {isLoading ? (
        <Skeleton variant="rectangular" width="100%" height="100%" />
      ) : (
        <TreemapWidget
          data={data?.map(item => ({ label: item['mitre_attack.tactic'], value: item.active_alerts_granular })) || []}
          selected={selected?.name}
          onSelect={tactic => {
            if (selected?.name === tactic) {
              onSelect?.(null as any);
            } else {
              const newSelection: SelectedWidgetData = {
                name: tactic,
                filter: { 'mitre_attack.tactic': [tactic] },
                tableType: TableDataType.ALERT,
              };
              onSelect?.(newSelection);
            }
          }}
        />
      )}
    </Box>
  );
};

export default AlertsMappedToTactic;
